export default __webpack_public_path__ + "static/media/mercury.08f8a62b.svg";